'use client';

// Top-right pill rendered on any card whose contents are mocked.
// Local copy — matches Ops + Exec pattern (backlog: hoist to @/components/common).
export default function DemoDataPill() {
  return (
    <span
      className="absolute top-3 right-3 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider"
      style={{ background: '#FEF3C7', color: '#92400E', letterSpacing: '0.08em' }}
    >
      DEMO DATA
    </span>
  );
}
